<template>
	<div>
		<div class="mdc-card mgt-16 pda-24" v-for="(product,index) in listData" :key="index" @click="moveToRegistarion(product.id)" @keypress="moveToRegistarion(product.id)" tabindex="0">
			<div class="d-flex cursor-pointer">
				<div class="edm-list-icon pdr-20" v-if="product && product.thumbnail && product.thumbnail.resourceUri">
					<img :src="product.thumbnail.resourceUri" alt="" class="b-radius4">
				</div>
				<div class="flex-grow-1 d-flex align-items-center">
					<div>
						<div class="t-body3 t-line-h-22 t-color-bodyGrayA  font-r">{{product.hcategoryNames}}</div>
						<div class="t-body1 l-spacing48 t-line-h-26 font-r">{{product.name}}</div>         
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * 단독 전체 시험 목록 메인 컴포넌트(independent total exam list main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define



//import { MDCTabBar} from "@material/tab-bar";


export default {
   
	props: ["listData"],
	data() {
		return {
			
			
		}
	},

	mounted(){

	},

	methods: {
		moveToRegistarion(id) {
			this.$router.push({
				name: 'StoreAdd',
				params: {goodsId: id},
			})
		}
	}
}
</script>
